"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoMarginTable = exports.Label = exports.Savings = exports.PriceSpan = exports.PriceToPay = exports.BasisPrice = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const themed_text_1 = require("../themed-text");
const setPriceStyles = (0, styled_components_1.css) `
  padding: 0 0 0 3px;
  width: 100%;
`;
exports.BasisPrice = styled_components_1.default.td `
  text-decoration: line-through;
  ${setPriceStyles};
`;
exports.PriceToPay = styled_components_1.default.td `
  ${setPriceStyles};
`;
exports.PriceSpan = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    color: ${(props) => props.color || props.theme.palettes.font.price};
  }
`;
exports.Savings = styled_components_1.default.td `
  ${setPriceStyles};
`;
exports.Label = styled_components_1.default.td `
  white-space: nowrap;
  text-align: right;
  vertical-align: top;
  padding-top: 0;
`;
exports.NoMarginTable = styled_components_1.default.table `
  margin-bottom: 0;
`;
